import {toast} from 'react-toastify';
import React from "react";
import {Box} from "@mui/material";

type propType = {
    title:string,
    message?:string
    autoClose?:number
    url?:string
}
const ToastMessage = ({ title, message }   :propType) => (
    <Box>
        <strong>{title}</strong>
        {message &&
            <div>{message}</div>
        }
    </Box>
);



// const notifications = useAppSelector(state => state.notifications);
//
// const [alertModal, setAlertModal] = useState("")
// useEffect(() => {
//     let noti = ((notifications ?? []) as {title:string}[])[0]?.title;
//     if(noti?.includes("agotado")){
//         setAlertModal(noti)
//     }
// }, [notifications, setAlertModal]);

// <ConfirmDialog
//     title={"Plan"}
//     primaryBtnText={"Ver Planes"}
//     open={!!alertModal}
//     mode={"warning"}
//     onClose={()=> {
//         setAlertModal("")
//     }}
//     onConfirm={()=> {
//         setAlertModal("")
//         Dispatch(togglePaypalPlan())
//     }}
// >
//     <DialogContentText>
//         {alertModal}
//     </DialogContentText>
// </ConfirmDialog>



const notify = {
    success: ({ title, message, autoClose, url }   :propType) => {
        return toast(<ToastMessage title={title} message={message} url={url} />, { type: 'success', autoClose:autoClose??3000, hideProgressBar: true, onClick:()=>{
                if(url?.includes("http")){
                    window.open(url, "_blank");
                }
            }});
    },
    error: ({ title, message, autoClose, url}   :propType) => {
        return toast(<ToastMessage title={title} message={message} url={url} />, { type: 'error', autoClose:autoClose??3000, hideProgressBar: true, onClick:()=>{
                if(url?.includes("http")){
                    window.open(url, "_blank");
                }
            }});
    },
    info: ({ title, message, autoClose, url }   :propType) => {
        return toast(<ToastMessage title={title} message={message} url={url} />, { type: 'info', autoClose:autoClose??3000, hideProgressBar: true, onClick:()=>{
                if(url?.includes("http")){
                    window.open(url, "_blank");
                }
            }});
    },
    warning: ({ title, message, autoClose, url }   :propType) => {
        return toast(<ToastMessage title={title} message={message} url={url} />, { type: 'warning', autoClose:autoClose??3000, hideProgressBar: true, onClick: ()=>{
                if(url?.includes("http")){
                    window.open(url, "_blank");
                }
            } });
    },
};

export default notify;
